import styled from 'styled-components';
import { GREAT_WHITE } from 'HubStyleTokens/colors';
import { H5 } from 'UIComponents/elements/headings';
import UITile from 'UIComponents/tile/UITile';
import UITileSection from 'UIComponents/tile/UITileSection';
import PopularFeaturesPanelImage from './PopularFeaturesPanelImage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledTile = styled(UITile).withConfig({
  displayName: "PopularFeatureCard__StyledTile",
  componentId: "p2h2nn-0"
})(["width:348px;border-radius:4px;border:1px solid ", ";"], GREAT_WHITE);
export const PopularFeatureCard = ({
  featureRecord,
  apiName
}) => {
  return /*#__PURE__*/_jsxs(StyledTile, {
    distance: "small",
    className: "m-top-0",
    children: [/*#__PURE__*/_jsx(UITileSection, {
      className: "p-all-6",
      children: /*#__PURE__*/_jsx(PopularFeaturesPanelImage, {
        featureRecord: featureRecord
      })
    }), /*#__PURE__*/_jsx(UITileSection, {
      className: "p-x-6 p-bottom-6",
      children: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(H5, {
          className: "m-bottom-2",
          children: featureRecord.displayName
        }), /*#__PURE__*/_jsx("p", {
          className: "m-bottom-0",
          children: featureRecord.descriptions[apiName]
        })]
      })
    })]
  });
};